module.exports = __webpack_public_path__ + "static/media/logomarca.1ba3197d.png";